<template>
  <a-modal title="抽取记录"
           :visible="historyVisible"
           @cancel="$emit('cancel')"
           @ok="$emit('success')"
           width="80%">
    <record-s-table :recordVisible="historyVisible"
                    :columns="columns"
                    :readOnly="readOnly"
                    :expertId="expertId" />
  </a-modal>
</template>
<script>
import moment from 'moment'
import { ApplyTypeEnum, ExtractExpertFlagEnum } from '@/epp/expertmain/selectexpertapply/utils/ExpertApplyUtils'
import RecordSTable from '@/epp/expertmain/expertInfo/common/record/RecordSTable.vue'

const columns = [
  {
    title: '活动时间',
    width: '200px',
    dataIndex: 'openDate',
    customRender: (text) => {
      return text && moment(text).format('YYYY年MM月DD日')
    }
  },
  {
    title: '项目名称',
    dataIndex: 'projectName',
    ellipsis: true,
    align: 'left',
  },
  {
    title: '项目编号',
    dataIndex: 'projectCode',
    align: 'center',
  },
  {
    title: '用途',
    customRender: (text, record) => {
      return record.applyType === ApplyTypeEnum.OTHER ? record.applyTypeOther : record.applyTypeText
    }
  },
  {
    title: '出席状态',
    width: '200px',
    dataIndex: 'expertFlagText',
  },
]
export default {
  name: 'ExpertEventHistoryRecord',
  computed: {},
  components: {
    RecordSTable,
  },
  props: {
    expertId: {
      type: String,
      default: ''
    },
    historyVisible: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      columns,
      ExtractExpertFlagEnum,
    }
  },
  watch: {},
  methods: {}
}
</script>
